export default "__VITE_ASSET__DiAPz_gY__"